import styled from '@emotion/styled'
import { Container } from '@mui/material'

import { theme as newTheme } from 'styles/theme/hav-theme'

export const ContainerStyled = styled(Container)`
  ${({ fullwidth }: { fullwidth: 'true' | 'false' }) => `    
      @media (min-width: ${newTheme.breakpoints.xl}px){
        max-width:${fullwidth === 'true' ? '100vw' : '1440px'};
      }
  `}
`
